import React from "react";
import { ComponentDetailsByFileOut } from "api-client";
import { observer } from "mobx-react-lite";
import ProductDetails from "../components/ProductDetails";
import { useTranslation } from "react-i18next";
import { searchStore } from "features/ProductSearch/SearchStore";
import { getCurrentReferenceUnitValue } from "features/MappingEditor/utils";
import ComponentChildOverview from "features/ComponentEditor/components/ComponentChildOverview";

const ComponentDetails = () => {
  const { i18n } = useTranslation();
  const isEng = i18n.language === "en";
  const { currentDetailNode: currentComponentNode } = searchStore;

  const referenceUnit = getCurrentReferenceUnitValue(
    currentComponentNode?.reference_unit
  );

  return currentComponentNode?.type === "PRODUCT" ? (
    <ProductDetails epdGroupsData={currentComponentNode.epd_groups} />
  ) : (
    currentComponentNode?.children?.map((item, index) => (
      <ComponentChildOverview
        key={index}
        childItem={item as unknown as ComponentDetailsByFileOut}
        referenceUnit={isEng ? referenceUnit?.name : referenceUnit?.name_de}
        hideInfoIcon
      />
    ))
  );
};

export default observer(ComponentDetails);
